import { render, staticRenderFns } from "./RightColumnOfPublicTender.vue?vue&type=template&id=8f951ba6&scoped=true&"
import script from "./RightColumnOfPublicTender.vue?vue&type=script&lang=js&"
export * from "./RightColumnOfPublicTender.vue?vue&type=script&lang=js&"
import style0 from "./RightColumnOfPublicTender.vue?vue&type=style&index=0&id=8f951ba6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f951ba6",
  null
  
)

export default component.exports